/**
 * Pickleball.com's legal pages, as URL paths.
 *
 * Two unrelated features need the same list: `AD_FREE_PAGES`, which keeps pubfig and its products
 * off these pages, and `FloatingMenu`, which hides itself here in a webview. Keeping one copy is
 * what stops the two drifting apart the next time a legal page is added.
 *
 * Exact paths, not patterns — these are leaf routes with no children.
 */
export const LEGAL_PAGES = ['/privacy-policy', '/terms-of-use', '/dmca-notice', '/betting-disclaimer', '/privacy-terms-dmca'] as const;

/** Trailing slash, query and hash are all tolerated; anything nested is not a legal page. */
export function isLegalPath(pathname: string | null | undefined): boolean {
	if (!pathname) return false;

	const [withoutQuery = ''] = pathname.split('?');
	const [pathOnly = ''] = withoutQuery.split('#');
	const normalized = pathOnly.length > 1 && pathOnly.endsWith('/') ? pathOnly.slice(0, -1) : pathOnly;

	return (LEGAL_PAGES as readonly string[]).includes(normalized);
}
